import React, { useState } from "react";
import Logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
// Simulating Material-UI icons
const MenuIcon = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);

const CloseIcon = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setIsOpen(false);
    // Simulate navigation
    console.log('Navigate to:', href);
  };

  return (
    <nav className="fixed w-full z-50 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 shadow-lg border-b border-blue-700/50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-4">
          <a href="/">
            <img
              src={Logo}
              alt="Temple"
              className="h-[40px] md:h-[50px] w-auto object-contain"
            />
          </a>
        </div>


        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-6 text-sm font-semibold text-white">
          <a
            href="/"
            // onClick={(e) => handleNavClick(e, '/')}
            className="hover:text-orange-400 transition-colors duration-300 relative group"
          >
            முகப்பு
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300"></span>
          </a>
          <a
            href="/#history"
            // onClick={(e) => handleNavClick(e, '/#history')}
            className="hover:text-orange-400 transition-colors duration-300 relative group"
          >
            வரலாறு
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300"></span>
          </a>
          <a
            href="/poojas"
            // onClick={(e) => handleNavClick(e, '/poojas')}
            className="hover:text-orange-400 transition-colors duration-300 relative group"
          >
            பணிவிடைகள்
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300"></span>
          </a>
          <a
            href="/gallery"
            // onClick={(e) => handleNavClick(e, '/gallery')}
            className="hover:text-orange-400 transition-colors duration-300 relative group"
          >
            ஆடியோ
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300"></span>
          </a>
        </div>

        {/* Desktop Button */}
        <div className="hidden md:block">
          <button
            onClick={() => navigate("/contact")}
            className="rounded-full bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-2.5 text-white font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            தொடர்புக்கு
          </button>
        </div>

        {/* Mobile Menu Icon */}
        <div className="md:hidden flex items-center">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none hover:text-orange-400 transition-colors duration-300"
            aria-label="Toggle menu"
          >
            {isOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-gradient-to-b from-blue-900 to-blue-950 border-t border-blue-700/50">
          <div className="flex flex-col items-center space-y-4 py-6 text-sm font-semibold text-white">
            <a
              href="/"
              // onClick={(e) => handleNavClick(e, '/')}
              className="hover:text-orange-400 transition-colors duration-300 w-full text-center py-2"
            >
              முகப்பு
            </a>
            <a
              href="/#history"
              // onClick={(e) => handleNavClick(e, '/#history')}
              className="hover:text-orange-400 transition-colors duration-300 w-full text-center py-2"
            >
              வரலாறு
            </a>
            <a
              href="/poojas"
              // onClick={(e) => handleNavClick(e, '/poojas')}
              className="hover:text-orange-400 transition-colors duration-300 w-full text-center py-2"
            >
              பணிவிடைகள்
            </a>
            <a
              href="/gallery"
              // onClick={(e) => handleNavClick(e, '/gallery')}
              className="hover:text-orange-400 transition-colors duration-300 w-full text-center py-2"
            >
              ஆடியோ
            </a>
            <button
              onClick={() => navigate("/contact")}

              className="rounded-full bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-2.5 text-white font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg mt-2"
            >
              தொடர்புக்கு
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}